
import { ElForm } from 'element-ui/types/form'
import { Component, Vue, Ref } from 'vue-property-decorator'
import { isChange } from '@/common/utils'

export type ShowType = 'show' | 'update' | 'create'

export interface AddReasonDialog {
    show(word: string, type: ShowType): void
    hide(): void
}

/**
 * 
 * @emit add        新增常用语
 * @emit update     更新常用语
 * 
*/
@Component({
    name: 'add-reason'
})
export default class extends Vue implements AddReasonDialog {
    @Ref('formRef') private formEl!: ElForm
    private dialogVisible = false
    private loading = false
    private type: ShowType = 'create'
    private form = {
        content: ''
    }
    private rules = {
        content: [
            { required: true, message: '请输入拒绝理由', trigger: 'blur' },
            { min: 2, max: 100, message: '拒绝理由范围在 2 - 100个字符之间', trigger: 'blur' }
        ]
    }
    private oldValue = ''

    get isShowButton() {
        return this.type !== 'show'
    }

    public show(word: string, type: ShowType = 'create') {
        if (word) this.form.content = word
        this.type = type
        if (type === 'update') {
            this.oldValue = word
        }
        this.dialogVisible = true
    }

    public hide() {
        this.formEl.resetFields()
        this.loading = false
        this.dialogVisible = false
    }

    // @Emit('add')
    private onAddWord() {
        this.formEl.validate((isValid: boolean) => {
            if (!isValid) return
            if (this.type === 'create') {
                this.loading = true
                this.$emit('add', this.form.content)
            } else if (this.type === 'update') {
                if (!isChange(this.oldValue, this.form.content)) {
                    this.$message({
                        type: 'warning',
                        message: '请先做出修改',
                        showClose: true
                    })
                    return
                }
                this.loading = true
                this.$emit('update', this.form.content)
            } else {
                this.hide()
            }
        })
    }
}
